<template>
    <div>
        <label for="item-select">Select a show:</label>
        <select id="item-select" v-model="selectedOption" @change="emitSelection">
            <option value="null" disabled selected>-- Please select an option --</option>
            <option v-for="show in showsList" :key="show.id" :value="show.id">
                {{ show.venue }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'ShowSelectionDropdown',
    props: {
        showsList: {
            type: Array,
            required: true,
            default: () => [],
        },
        initialValue: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            selectedOption: this.initialValue,
        };
    },
    methods: {
        emitSelection() {
            // debug.... console.log('Selected option:', this.selectedOption);
            this.$emit('selection-changed', this.selectedOption);
        },
    },
    watch: {
        initialValue(newValue) {
            this.selectedOption = newValue;
        }
    }
};
</script>

<style scoped>
#item-select {
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
    font-size: 1rem;
    color: #333;
    cursor: pointer;
    min-width: 400px;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

/* Style on focus */
#item-select:focus {
    outline: none;
    border-color: #007bff;
    /* Example focus color */
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    /* Example focus shadow */
}

/* Style disabled option */
#item-select option[disabled] {
    color: #999;
}
</style>